<script>
	import DynamicZone from '$lib/modules/cms/DynamicZone/DynamicZone.svelte'
	import { HEAT_PUMP_3050 } from '$lib/routes'
	import { BoxLinks, OrderedList, VideoBanner } from '$lib/ui-woltair/components'
	import HeaderBrand from './@modules/Header.svelte'
	import Item from './@modules/Item.svelte'
	import { PUBLIC_WOLTAIR_WEB_CODE } from '$env/static/public'

	export let data

	const inStockSlugs = [
		'lg',
		'grundig',
		'samsung',
		'viessmann',
		'wltr',
		'alpha-innotec',
		'daikin',
		'regulus',
		'stiebel-eltron'
	]

	const boxLinks = data?.boxLinks?.map((boxLink) => {
		return {
			...boxLink,
			image: {
				url: boxLink?.image?.data?.attributes?.url
			}
		}
	})
</script>

{#if data.type === 'brandPage'}
	<HeaderBrand header={data.header} {inStockSlugs} />
	<section class="page-wrapper">
		<Item items={data.items} reviewAuthor={data.reviewAuthor} />
		<BoxLinks {boxLinks} />
		<OrderedList content={data.orderedList} />
		<VideoBanner
			content={{
				button_url: PUBLIC_WOLTAIR_WEB_CODE === 'WOLTAIR_IT' ? `/${HEAT_PUMP_3050}` : undefined
			}}
		/>
	</section>
{:else if data.type === 'productPage'}
	<main class="page-wrapper mb-16 flex flex-col items-center">
		{#if data.type === 'landingPage'}<h1 class="!mb-12 text-center">{@html data.title}</h1>{/if}

		<div class="flex w-full flex-col gap-4">
			<DynamicZone componentData={data.components} />
		</div>
	</main>
{/if}
